// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"02cf77f4","84":"750371b7","247":"f38be91d","453":"2b55c83a","627":"7b56a659","867":"bb5decd8","923":"95aa58f7"}[chunkId] + ".chunk.js";
};